import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { PAYMENTS_REPORT_ID } from './paymentsReportId';

const defaultColumns = [
    FIELDS.PAYMENT_METHOD.field,
    FIELDS.BILLING_DATE.field,
    FIELDS.PAYMENT_AMOUNT.field,
    FIELDS.FEES.field,
    FIELDS.VAT.field,
    FIELDS.PAYMENT_STATUS.field,
].map(field => generateColumnId(PAYMENTS_REPORT_ID, field));

export { defaultColumns };
